import { combineReducers } from "redux";
import user from "./user/reducer";
import dealer from "./dealer/reducer";
import country from "./country/reducer";
import auth from "./auth/reducer";
import manualAddFund from "./manualAddFund/reducer";
import plan from "./plan/reducer";
import network from "./network/reducer";
import activationRequest from "./activationRequest/reducer";
import profile from "./profile/reducer";
import planWiseMapping from "./planWiseMapping/reducer";
import dashboard from "./dashboard/reducer";
import shortCode from "./shortCodeData/reducer";
import activationStatus from "./activationStatus/reducer";
import mdnSwap from "./MDNSwap/reducer";
import chatrActivation from "./chatrActivation/reducer";
import simPinInventory from "../redux/SIMPINInventory/reducer";
import chatrActivationReport from "../redux/ChatrActivationReport/reducer";
import mdnSwapReport from "../redux/MDNSwapReport/reducer";
import chatrRechargePlan from "../redux/chatrRechargePlan/reducer";
import rechargePriceMapping from "../redux/rechargePriceMapping/reducer";
import chatrRecharge from "../redux/Chatr Recharge Request/reducer";
import chatrRechargeReport from "../redux/ChatrRechargeReport/reducer";

const rootReducer = combineReducers({
  user,
  country,
  manualAddFund,
  plan,
  dealer,
  auth,
  network,
  activationRequest,
  activationStatus,
  profile,
  planWiseMapping,
  dashboard,
  shortCode,
  mdnSwap,
  chatrActivation,
  simPinInventory,
  chatrActivationReport,
  mdnSwapReport,
  chatrRechargePlan,
  rechargePriceMapping,
  chatrRecharge,
  chatrRechargeReport,
});
export default rootReducer;
